/**
 * Filter for Client/BU  Name if it is modified
 */
var filter = function () {
    return function (clientName, isClientGlobalCopy) {
        console.log(clientName, isClientGlobalCopy);
        var output = clientName;
        if (!isClientGlobalCopy) {
            return output + " (Modified)";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var ClientOrBuModifiedFilter = {
    name: 'clientorbuModified',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-client-or-bu-modified.filter.js.map